import { render, staticRenderFns } from "./certificationAudit.vue?vue&type=template&id=46b57431&scoped=true"
import script from "./certificationAudit.vue?vue&type=script&lang=js"
export * from "./certificationAudit.vue?vue&type=script&lang=js"
import style0 from "./certificationAudit.vue?vue&type=style&index=0&id=46b57431&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b57431",
  null
  
)

export default component.exports